// src/main.js
import { createIcons, icons } from 'lucide';

document.addEventListener('DOMContentLoaded', () => {
    createIcons({ icons });

    // ── Hero Slider ───────────────────────────────────────────────
    let currentSlide = 0;
    const slides = document.querySelectorAll('.slide');

    function showSlide(index) {
        slides.forEach(s => s.classList.remove('active'));
        slides[index].classList.add('active');
    }

    window.nextSlide = function () {
        currentSlide = (currentSlide + 1) % slides.length;
        showSlide(currentSlide);
    }

    window.prevSlide = function () {
        currentSlide = (currentSlide - 1 + slides.length) % slides.length;
        showSlide(currentSlide);
    }

    if (slides.length > 1) {
        setInterval(window.nextSlide, 6000);
    }

    // ── Mobile Menu (if you have it) ──────────────────────────────
    window.toggleMenu = function () {
        const menu = document.getElementById('mobile-menu');
        if (menu) menu.classList.toggle('-translate-x-full');
    };

    // ── Filter Tabs ───────────────────────────────────────────────
    window.filterItems = function (category, el) {
        document.querySelectorAll('.filter-tab').forEach(tab => tab.classList.remove('active'));
        el.classList.add('active');

        document.querySelectorAll('.product-item').forEach(item => {
            if (category === 'all' || item.dataset.category === category) {
                item.style.display = 'block';
            } else {
                item.style.display = 'none';
            }
        });
    };

    // ── Add to Cart Animation ─────────────────────────────────────
    let count = 0;
    window.addToCart = function (btn) {
        count++;
        const cartCount = document.getElementById('cartCount');
        const mainBtn = document.getElementById('mainCartBtn');

        if (cartCount) cartCount.innerText = count;

        mainBtn?.classList.add('cart-animate');
        btn.innerHTML = '<i data-lucide="check" class="w-5 h-5"></i>';
        createIcons({ icons });

        setTimeout(() => {
            mainBtn?.classList.remove('cart-animate');
            btn.innerHTML = '<i data-lucide="shopping-cart" class="w-5 h-5"></i>';
            createIcons({ icons });
        }, 1000);
    };

    // ── Social Proof Toast ────────────────────────────────────────
    const spData = [
        { name: "Rahul from Bangalore", product: "Estate Arabica", img: "https://images.unsplash.com/photo-1514432324607-a09d9b4aefdd?w=100" },
        { name: "Ananya from Mumbai", product: "Almond Rocks", img: "https://images.unsplash.com/photo-1548907040-4baa42d10919?w=100" },
        { name: "Karthik from Chennai", product: "Morning Bundle", img: "https://images.unsplash.com/photo-1511537632536-b7a4896848a5?w=100" }
    ];

    window.showSocialProof = function () {
        const toast = document.getElementById('social-proof');
        if (!toast) return;

        const item = spData[Math.floor(Math.random() * spData.length)];

        const spImg = document.getElementById('sp-img');
        const spText = document.getElementById('sp-text');

        if (spImg) spImg.src = item.img;
        if (spText) spText.innerText = `${item.name} bought ${item.product}`;

        toast.classList.add('active');
        setTimeout(() => toast.classList.remove('active'), 5000);
    }

    setInterval(window.showSocialProof, 20000);
    setTimeout(window.showSocialProof, 5000);

    // ── Site Popup (cookie-based) ────────────────────────────────
    (function () {
        const overlay = document.getElementById('toc-popup-overlay');
        const closeBtn = document.getElementById('toc-popup-close');
        if (!overlay || !closeBtn) return;

        const config = window.tocPopupConfig || { cookieDays: 15, version: 'v1' };
        const cookieName = 'toc_popup_dismissed_' + config.version;

        // Cookie helpers
        function getCookie(name) {
            const match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
            return match ? match[2] : null;
        }

        function setCookie(name, value, days) {
            const d = new Date();
            d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
            document.cookie = name + '=' + value + ';expires=' + d.toUTCString() + ';path=/;SameSite=Lax';
        }

        // Already dismissed this version?
        if (getCookie(cookieName)) return;

        // Show popup after a short delay for better UX
        setTimeout(function () {
            overlay.style.display = 'flex';
            // Trigger reflow then add active class for animation
            requestAnimationFrame(function () {
                overlay.classList.add('toc-popup-overlay--active');
            });
            // Reinit icons inside the popup
            createIcons({ icons });
        }, 2000);

        // Close handler
        function closePopup() {
            overlay.classList.remove('toc-popup-overlay--active');
            setTimeout(function () { overlay.style.display = 'none'; }, 350);
            setCookie(cookieName, '1', config.cookieDays);
        }

        closeBtn.addEventListener('click', closePopup);

        // Close on overlay background click
        overlay.addEventListener('click', function (e) {
            if (e.target === overlay) closePopup();
        });

        // Close on Escape key
        document.addEventListener('keydown', function (e) {
            if (e.key === 'Escape' && overlay.style.display === 'flex') closePopup();
        });
    })();
});